import { render } from "./perScheduling.vue?vue&type=template&id=73f8710c&scoped=true"
import script from "./perScheduling.vue?vue&type=script&lang=js"
export * from "./perScheduling.vue?vue&type=script&lang=js"

import "./perScheduling.vue?vue&type=style&index=0&id=73f8710c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f8710c"]])

export default __exports__